import { createSlice } from '@reduxjs/toolkit';
import {
  ATTEMPT_LOGIN,
  REQUEST_LOGIN_USER_ERROR,
  REQUEST_LOGIN_USER_INVALID,
  REQUEST_LOGIN_USER_SUCCESS
} from '../constants/constants';

const initialState = {
  performingRequest: false,
  error: false,
  errMsg: {},
  loggedIn: false,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(ATTEMPT_LOGIN, state => {
        state.performingRequest = true;
      })
      .addCase(REQUEST_LOGIN_USER_SUCCESS, (state, action) => {
        state.user = action.data;
        state.performingRequest = false;
        state.error = false;
        state.errMsg = {};
        state.loggedIn = true;
      })
      .addMatcher(
        action => action.type === REQUEST_LOGIN_USER_ERROR || action.type === REQUEST_LOGIN_USER_INVALID,
        (state, action) => {
          state.performingRequest = false;
          state.error = true;
          state.errMsg = action.errMsg;
        }
      );
  }
});

export default loginSlice.reducer;
